import { gql } from '@apollo/client';
/**
 * @const ClientListExternalQuery
 * @since 1.0.0
 */
export const ClientListExternalQuery = gql `
  query ClientListExternalQuery($input: ClientsInput) {
    clientsExternal(input: $input) {
      items {
        id
        name
        asset
      }
      count
    }
  }
`;
